import { isBrowser } from "../../../../../common/helpers/env";
import React, { useEffect, useRef, useState } from "react";

import Wrapper from "../../Wrapper";

import NotEdited from "../Common/NotEdited";

import { StyledEmbed, Preview } from "./styles";
import { ICommonTaskProps, ISubScoreData } from "../../../../../common/types";
import { aspectRatio, getEndSeconds, getStartSeconds } from "../../../../../common/parameters";
import youtubeApi from "./youtubeApi";
import ScoreVideoSlide from "./ScoreVideoSlide";
import player from "../../../../player";

import Clock from "waaclock";

const SubScore = (props: ICommonTaskProps) => {
    const domId = useRef("player_" + Date.now()).current;
    const [currentPoint, setCurrentPoint] = useState(0);
    const [hasAudioContext, setHasAudioContext] = useState(isBrowser ? player.context.state === "running" : false);
    useEffect(() => {
        const check = () => {
            setHasAudioContext(player.context.state === "running");
        }
        if (!hasAudioContext) {
            player.context.addEventListener("statechange", check);
        }
        return () => {
            player.context.removeEventListener("statechange", check);
        }
    }, [setHasAudioContext]);
    const clock = useRef<any>(null);
    if (props.setReset) {
        props.setReset(() => { });
    }
    if (props.saveState) {
        props.saveState(() => ({}));
    }
    if (props.restoreState) {
        props.restoreState(() => { });
    }
    if (props.showSolution) {
        props.showSolution(() => { });
    }
    const { preview, task, isExperienceCenter } = props;
    const data = task.data as ISubScoreData;
    const videoPlayer = useRef<any>(null);

    const removeAllEvents = () => {
        if (!clock.current) return;
        clock.current.stop();
        clock.current = undefined;
        setCurrentPoint(0);
    }
    const rescheduleEvents = () => {
        const videoCurrentTime = videoPlayer.current!.getCurrentTime();
        clock.current = new Clock(player.context, { toleranceEarly: 0.1 })
        clock.current.start();
        let late = 0;
        data.points.forEach((point, index) => {
            const t = (point - videoCurrentTime);
            if (t < 0) return;
            clock.current.callbackAtTime(() => {
                setCurrentPoint(index + 1);
            }, player.context.currentTime + t + late);
        });
    }
    const onPlayerStateChange = ({ data: state }: { data: number }) => {
        if (state === 1) {
            rescheduleEvents();
        } else {
            removeAllEvents();
        }
    }
    const setupVideo = () => {
        if (!window.YT || !window.YT.Player || !document.getElementById(domId)) {
            setTimeout(setupVideo, 50);
            return;
        }
        videoPlayer.current = new window.YT.Player(domId, {
            height: aspectRatio.height,
            width: aspectRatio.width,
            videoId: data.href,
            playerVars: {
                playsinline: 1,
                fs: 0,
                start: getStartSeconds(data),
                end: getEndSeconds(data),
            },
            events: {
                'onStateChange': onPlayerStateChange
            }
        });
    }
    useEffect(() => {
        youtubeApi();
        setTimeout(setupVideo, 50);
    }, []);

    if (!data || !data.href || !data.scores || data.scores.length === 0 || !data.points || data.points.length === 0)
        return (
            <div>
                <Wrapper>
                    <NotEdited />
                </Wrapper>
            </div>
        );

    return (
        <div>
            <Wrapper isExperienceCenter={isExperienceCenter}>
                <StyledEmbed>
                    <ScoreVideoSlide scores={data.scores} currentPoint={currentPoint} width={aspectRatio.width} opacity={data.opacity || 0.5} notFollowNotes={data.notFollowNotes} />
                    {!preview ? (
                        <div onClick={() => {
                            if (!hasAudioContext) {
                                player.resumeContext();
                            }
                        }} style={{ cursor: "pointer" }}>
                            <div style={{ pointerEvents: hasAudioContext ? "auto" : "none" }}>
                                <div id={domId}/>
                            </div>
                        </div>
                    ) : (
                        <Preview
                            style={{
                                backgroundImage:
                                    `url("${`//i3.ytimg.com/vi/${data.href}/hqdefault.jpg`}")`
                            }}
                        />
                    )}
                </StyledEmbed>
            </Wrapper>
        </div>
    );
}

export default SubScore;
